<template>
  <div class="shop-store-container">
    <!-- 顶部标签页区域 -->
    <div class="page-header">
      <!-- 将下拉菜单改为标签页选项卡 -->
      <div class="tabs-container">
        <el-tabs 
          v-model="currentWarehouseId" 
          type="card" 
          @tab-click="handleTabChange"
          class="warehouse-tabs"
        >
          <el-tab-pane 
            v-for="warehouse in warehouseOptions" 
            :key="warehouse.id"
            :name="warehouse.id.toString()"
            :label="warehouse.label"
          >
            <span slot="label" class="tab-label">
              {{ warehouse.label }}
            </span>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 条件筛选区域 -->
    <div class="filter-container">
      <el-form 
        :inline="true" 
        :model="filterForm" 
        class="filter-form"
        size="mini"
        :label-width="'80px'"
      >
        <!-- 第一行筛选条件 -->
        <div class="filter-row">
          <el-form-item label="入库状态">
            <el-select
              v-model="filterForm.state"
              placeholder="请选择入库状态"
              clearable
              style="width: 120px"
            >
              <el-option label="草稿" :value="0"></el-option>
              <el-option label="已提交" :value="2"></el-option>
              <el-option label="已审核" :value="4"></el-option>
              <el-option label="已过单" :value="5"></el-option>
              <el-option label="已冲销" :value="6"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="入库类型">
            <el-select
              v-model="filterForm.putinTypeId"
              placeholder="请选择入库类型"
              clearable
              style="width: 120px"
            >
              <el-option label="采购入库" :value="1"></el-option>
              <el-option label="其他入库" :value="2"></el-option>
              <el-option label="赠送入库" :value="3"></el-option>
              <el-option label="调拨入库" :value="4"></el-option>
			  <el-option label="系统切换入库" :value="5"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item>
            <el-button 
              type="primary" 
              icon="el-icon-Ssearch"
              @click="handleSearch"
            >
              搜索
            </el-button>
            <el-button 
              icon="el-icon-refresh"
              @click="handleReset"
            >
              数据更新
            </el-button>
            <el-button 
              type="text" 
              @click="toggleExpanded"
              class="expand-btn"
            >
              <i :class="expanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              {{ expanded ? '收起' : '展开' }}
            </el-button>
          </el-form-item>
        </div>
        
        <!-- 扩展的筛选条件 -->
        <transition name="el-zoom-in-top">
          <div v-if="expanded" class="expanded-filters">
            <el-form-item label="药品名称">
              <el-input
                v-model="filterForm.drugName"
                placeholder="请输入药品名称"
                clearable
                style="width: 150px"
              ></el-input>
            </el-form-item>
			
			<el-form-item label="入库编号">
			  <el-input
			    v-model="filterForm.docNum"
			    placeholder="请输入入库编号"
			    clearable
			    style="width: 150px"
			  ></el-input>
			</el-form-item>
			
			<el-form-item label="供应商">
			  <el-input
			    v-model="filterForm.supplierName"
			    placeholder="请输入供应商"
			    clearable
			    style="width: 150px"
			  ></el-input>
			</el-form-item>
						
            <el-form-item label="日期范围">
              <el-date-picker
                v-model="filterForm.dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                style="width: 250px"
                @change="handleDateChange"
              ></el-date-picker>
            </el-form-item>
          </div>
        </transition>
      </el-form>
    </div>

    <!-- 表格区域标题 -->
    <div class="table-header">
      <h3 class="table-title">{{ currentWarehouse.label }}采购列表清单</h3>
    </div>

    <!-- 动态组件显示不同库房的采购列表 -->
    <div class="table-container">
      <transition name="fade-slide" mode="out-in">
        <component 
          :is="currentComponent" 
          :key="currentWarehouse.id"
          :filterData="filterForm"
          @create-inbound="handleCreateInbound"
          @edit-inbound="handleEditInbound"
          @view-inbound="handleViewInbound"
          @confirm-inbound="handleConfirmInbound"
          @delete-inbound="handleDeleteInbound"
          @print-inbound="handlePrintInbound"
          @switch-warehouse="handleSwitchWarehouseFromChild"
        ></component>
      </transition>
    </div>

    <!-- 欢迎模态框 -->
    <el-dialog
      title="系统提示"
      :visible.sync="welcomeDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :before-close="handleCloseWelcome"
      custom-class="welcome-dialog"
    >
      <div class="welcome-content">
        <div class="welcome-icon">
          <i class="el-icon-success"></i>
        </div>
        <div class="welcome-text">
          <h4>欢迎使用药品采购入库系统</h4>
          <p>当前默认操作库为：<strong>{{ currentWarehouse.label }}</strong></p>
          <p>此提示将在 <span class="countdown">{{ countdown }}</span> 秒后自动关闭</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button 
          type="primary" 
          size="small" 
          @click="handleCloseWelcome"
        >
          我已知晓 ({{ countdown }}s)
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 引入子组件
import XYK from './Western/xyk/xyk.vue'      // 西药库
import ZYK from './Western/zyk/zyk.vue'      // 中药库
import XYF from './Western/xyf/xyf.vue'      // 西药房
import ZYF from './Western/zyf/zyf.vue'      // 中药房
import WCK from './Western/wck/wck.vue'      // 中药房

export default {
  name: 'ShopStore',
  components: {
    XYK,
    ZYK,
    XYF,
    ZYF,
	WCK
  },
  data() {
    return {
      // 库房选项 - 新增耗材库选项
      warehouseOptions: [
        { id: 1, label: '西药库', value: 'xyk' },
        { id: 2, label: '西药房', value: 'xyf' },
        { id: 3, label: '中药库', value: 'zyk' },
        { id: 4, label: '中药房', value: 'zyf' },
        { id: 5, label: '耗材库', value: 'hck' }  // 新增耗材库选项
      ],
      
      // 当前选择的库房
      currentWarehouse: { id: 1, label: '西药库', value: 'xyk' },
      currentWarehouseId: '1',  // 用于tabs绑定的值
      
      // 当前组件
      currentComponent: 'XYK',
      // 新增：存储下拉菜单位置信息
      dropdownPosition: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      },
      // 筛选表单 - 调整为接口参数
      filterForm: {
        state: '',        // 入库状态
        putinTypeId: '',  // 入库类型ID
        docNum: '',             // 入库编号
        supplierName: '',       // 供应商名称
        drugName: '',           // 药品名称
        startDate: '',          // 开始日期
        endDate: ''             // 结束日期
      },
      
      // 是否展开更多筛选条件
      expanded: false,
      
      // 欢迎模态框控制
      welcomeDialogVisible: false,
      countdown: 3,
      countdownTimer: null,
      // 新增：是否初次加载页面标志
      isInitialLoad: true,
      
      dialogPosition: null,
    };
  },
  computed: {
    // 计算当前组件名称
    computedComponent() {
      const map = {
        1: 'XYK',
        2: 'XYF', 
        3: 'ZYK',
        4: 'ZYF',
        5: 'WCK'  // 耗材库暂时使用西药库组件，后续可根据需要更改
      };
      return map[this.currentWarehouse.id] || 'XYK';
    }
  },
  watch: {
    // 监听当前库房变化
    currentWarehouse: {
      handler(newVal) {
        this.currentComponent = this.computedComponent;
      },
      immediate: true
    }
  },
  mounted() {
    // 仅在页面初次加载时显示欢迎模态框
    if (this.isInitialLoad) {
      // 计算下拉菜单位置
      this.calculateDropdownPosition();
      
      // 等待DOM渲染完成后显示模态框
      this.$nextTick(() => {
        setTimeout(() => {
          // this.welcomeDialogVisible = true;
          this.startCountdown();
        }, 100);
      });
      
      this.isInitialLoad = false;
    }
  },
  beforeDestroy() {
    // 清除定时器和事件监听
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },
  methods: {
    // 计算下拉菜单位置
    calculateDropdownPosition() {
      this.$nextTick(() => {
        const dropdownElement = document.querySelector('.warehouse-dropdown');
        if (dropdownElement) {
          const rect = dropdownElement.getBoundingClientRect();
          const containerRect = this.$el.getBoundingClientRect();
          
          // 计算相对于容器的位置
          this.dropdownPosition = {
            x: rect.left - containerRect.left + rect.width / 2,
            y: rect.top - containerRect.top + rect.height / 2,
            width: rect.width,
            height: rect.height
          };
        }
      });
    },
    
    // 新增：处理子组件触发的药库切换
    handleSwitchWarehouseFromChild(warehouseId) {
      console.log('收到子组件切换药库请求:', warehouseId);
      
      // 根据warehouseId找到对应的药库对象
      const targetWarehouse = this.warehouseOptions.find(item => item.id === warehouseId);
      
      if (targetWarehouse) {
        console.log('切换到药库:', targetWarehouse.label);
        
        // 调用已有的药库切换方法
        this.handleWarehouseChange(targetWarehouse);
        
        // 显示切换成功的消息
        this.$message.success(`已自动切换到${targetWarehouse.label}列表`);
      } else {
        console.error('未找到对应的药库，warehouseId:', warehouseId);
        this.$message.warning('自动切换药库失败，请手动切换');
      }
    },
    
    // 标签页切换
    handleTabChange(tab) {
      const warehouseId = parseInt(tab.name);
      const warehouse = this.warehouseOptions.find(item => item.id === warehouseId);
      
      if (warehouse) {
        this.handleWarehouseChange(warehouse);
      }
    },
    
    // 切换库房
    handleWarehouseChange(warehouse) {
      console.log('切换到库房:', warehouse.label);
      
      // 更新当前仓库
      this.currentWarehouse = warehouse;
      this.currentWarehouseId = warehouse.id.toString();
      
      // 显示欢迎消息
      this.showWelcomeMessage();
      
      // 通知子组件药库已切换
      this.$emit('warehouse-changed', warehouse.id);
      
      // 重置筛选条件
      this.handleReset();
    },
    
    // 搜索
    handleSearch() {
      console.log('搜索条件:', this.filterForm);
      // 这里触发子组件的搜索方法
      this.$emit('search', this.filterForm);
    },
    
    // 重置搜索条件
    handleReset() {
      this.filterForm = {
        state: '',
        putinTypeId: '',
        docNum: '',
        supplierName: '',
        drugName: '',
        dateRange: [],
        startDate: '',
        endDate: ''
      };
      this.expanded = false;
    },
    
    // 日期选择变化处理
    handleDateChange(dateRange) {
      if (dateRange && dateRange.length === 2) {
        this.filterForm.startDate = dateRange[0];
        this.filterForm.endDate = dateRange[1];
      } else {
        this.filterForm.startDate = '';
        this.filterForm.endDate = '';
      }
    },
    
    // 切换展开/收起
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
    
    // 创建入库单
    handleCreateInbound() {
      console.log('创建入库单');
      this.$message.info('创建入库单功能待实现');
    },
    
    // 批量入库
    handleBatchInbound() {
      console.log('批量入库');
      this.$message.info('批量入库功能待实现');
    },
    
    // 编辑入库单
    handleEditInbound(row) {
      console.log('编辑入库单:', row);
      this.$message.info('编辑入库单功能待实现');
    },
    
    // 查看入库单
    handleViewInbound(row) {
      console.log('查看入库单:', row);
      this.$message.info('查看入库单功能待实现');
    },
    
    // 确认入库
    handleConfirmInbound(row) {
      console.log('确认入库:', row);
      this.$message.info('确认入库功能待实现');
    },
    
    // 删除入库单
    handleDeleteInbound(row) {
      console.log('删除入库单:', row);
      this.$message.info('删除入库单功能待实现');
    },
    
    // 打印入库单
    handlePrintInbound(row) {
      console.log('打印入库单:', row);
      this.$message.info('打印入库单功能待实现');
    },
    
    // 显示欢迎消息
    showWelcomeMessage() {
      // this.welcomeDialogVisible = true;
      this.countdown = 3;
      this.startCountdown();
    },
    
    // 开始倒计时
    startCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.handleCloseWelcome();
        }
      }, 1000);
    },
    
    // 关闭欢迎模态框
    handleCloseWelcome() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      
      // 获取模态框元素
      const dialogElement = document.querySelector('.welcome-dialog');
      if (dialogElement) {
        // 计算模态框中心点到下拉菜单中心的向量
        const dialogRect = dialogElement.getBoundingClientRect();
        const containerRect = this.$el.getBoundingClientRect();
        
        const dialogCenterX = dialogRect.left - containerRect.left + dialogRect.width / 2;
        const dialogCenterY = dialogRect.top - containerRect.top + dialogRect.height / 2;
        
        // 计算需要移动的距离
        const moveX = this.dropdownPosition.x - dialogCenterX;
        const moveY = this.dropdownPosition.y - dialogCenterY;
        
        // 计算缩放比例
        const scaleX = this.dropdownPosition.width / dialogRect.width;
        const scaleY = this.dropdownPosition.height / dialogRect.height;
        const scale = Math.min(scaleX, scaleY) * 0.3; // 缩小到30%的下拉菜单大小
        
        // 应用动画效果
        dialogElement.style.transition = 'all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)';
        dialogElement.style.transform = `translate(${moveX}px, ${moveY}px) scale(${scale})`;
        dialogElement.style.opacity = '0';
      }
      
      // 延迟关闭模态框
      setTimeout(() => {
        this.welcomeDialogVisible = false;
        
        // 重置样式
        if (dialogElement) {
          dialogElement.style.transition = '';
          dialogElement.style.transform = '';
          dialogElement.style.opacity = '';
        }
      }, 600);
    },
    
    // 计算下拉菜单位置
    calculateDialogPosition() {
      const dropdownElement = document.querySelector('.warehouse-dropdown');
      if (dropdownElement) {
        const rect = dropdownElement.getBoundingClientRect();
        const dialogWidth = 400; // 模态框宽度
        const dialogHeight = 200; // 模态框高度
        const dropdownWidth = rect.width;
        const dropdownHeight = rect.height;
        
        // 计算模态框需要移动到的位置（下拉菜单位置）
        const x = rect.left + dropdownWidth / 2 - dialogWidth / 2;
        const y = rect.top + dropdownHeight / 2 - dialogHeight / 2;
        
        this.dialogPosition = { x, y };
      }
    }
  }
};
</script>

<style lang="less" scoped>
.shop-store-container {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 120px);
  background-color: #f5f7fa;
  overflow: hidden;
  box-sizing: border-box;
  
  .page-header {
    margin-bottom: 4px;
    background-color: #fff;
    padding: 12px 0 12px 0;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    
    .tabs-container {
      .warehouse-tabs {
        /deep/ .el-tabs__header {
          margin-bottom: 0;
          border-bottom: none;
        }
        
        /deep/ .el-tabs__nav {
          border: none;
          border-radius: 4px;
          overflow: hidden;
        }
        
        /deep/ .el-tabs__item {
          position: relative;
          padding: 0 20px;
          height: 36px;
          line-height: 36px;
          font-size: 14px;
          font-weight: 500;
          color: #606266;
          border: 1px solid #e4e7ed;
          background-color: #fff;
          transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
          border-radius: 4px 4px 0 0;
          margin-right: 4px;
          
          &:first-child {
            border-left: 1px solid #e4e7ed;
          }
          
          &:hover {
            color: #409EFF;
            background-color: rgba(64, 158, 255, 0.08);
            border-color: #c6e2ff;
            z-index: 2;
          }
          
          &.is-active {
            color: #fff;
            background-color: #409EFF;
            border-color: #409EFF;
            z-index: 3;
            
            .tab-label {
              color: #fff;
            }
            
            &::after {
              content: '';
              position: absolute;
              bottom: -1px;
              left: 0;
              right: 0;
              height: 2px;
              background-color: #409EFF;
              z-index: 4;
            }
          }
          
          .tab-label {
            display: inline-block;
            transition: color 0.3s;
            color: inherit;
          }
        }
        
        /deep/ .el-tabs__nav-wrap::after {
          display: none;
        }
      }
    }
  }
  
  .filter-container {
    background-color: #fff;
    border-radius: 4px;
    padding: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    
    .filter-form {
      margin-bottom: 0;
      
      .filter-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;
      }
      
      .expanded-filters {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;
        padding-top: 15px;
        border-top: 1px solid #e8e8e8;
        margin-top: 10px;
        animation-duration: 0.3s;
      }
      
      .expand-btn {
        padding-left: 10px;
        padding-right: 10px;
        
        i {
          margin-right: 5px;
        }
      }
    }
  }
  
  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    padding: 12px 16px;
    margin-bottom: 10px;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    
    .table-title {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
      color: #333;
    }
    
    .header-actions {
      display: flex;
      gap: 10px;
    }
  }
  
  .table-container {
    flex: 1;
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border: 1px solid #e4e7ed;
    transition: all 0.3s ease;
  }
}

// 下拉菜单项激活样式
/deep/ .el-dropdown-menu {
  .is-active {
    color: #409EFF;
    background-color: #f0f9ff;
  }
}

// 欢迎模态框样式 - 添加动画相关样式
/deep/ .welcome-dialog {
  transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
  transform-origin: center !important;
  
  .el-dialog__header {
    padding-bottom: 10px;
    border-bottom: 1px solid #e8e8e8;
  }
  
  .el-dialog__title {
    font-size: 16px;
    color: #409EFF;
  }
  
  .welcome-content {
    display: flex;
    align-items: center;
    padding: 20px 0;
    
    .welcome-icon {
      margin-right: 20px;
      
      i {
        font-size: 48px;
        color: #67C23A;
      }
    }
    
    .welcome-text {
      flex: 1;
      
      h4 {
        margin: 0 0 10px 0;
        font-size: 18px;
        color: #333;
      }
      
      p {
        margin: 5px 0;
        color: #666;
        
        .countdown {
          color: #F56C6C;
          font-weight: bold;
        }
      }
    }
  }
  
  .dialog-footer {
    .el-button {
      min-width: 120px;
    }
  }
}

// 丝滑切换动画
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter {
  opacity: 0;
  transform: translateX(20px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}

.fade-slide-enter-to,
.fade-slide-leave {
  opacity: 1;
  transform: translateX(0);
}

// 响应式适配
@media (max-width: 768px) {
  .shop-store-container {
    padding: 5px;
    
    .page-header {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
      
      .tabs-container {
        overflow-x: auto;
        
        .warehouse-tabs {
          /deep/ .el-tabs__nav-scroll {
            overflow-x: auto;
            white-space: nowrap;
          }
          
          /deep/ .el-tabs__nav {
            display: inline-flex;
            flex-wrap: nowrap;
          }
        }
      }
      
      .header-actions {
        justify-content: center;
      }
    }
    
    .filter-container {
      .filter-form {
        .filter-row,
        .expanded-filters {
          flex-direction: column;
          align-items: stretch;
        }
      }
    }
  }
}
</style>